const dns_management = {
	error_while_fetching_dns_records:
		"An error occurred while retrieving the DNS records. If the problem persists, please contact our customer service.",
	external_nameservers:
		"The DNS records can't be edited because this domain uses external nameservers.",
	not_available:
		"The DNS records are not available because the domain is not under your management (anymore).",
	title: "Manage DNS",
	update_success: "The new DNS settings were saved successfully.",
};

export default dns_management;
